import { render, staticRenderFns } from "./CategoriaDeArvore.vue?vue&type=template&id=f8d7fc06&scoped=true"
import script from "./CategoriaDeArvore.vue?vue&type=script&lang=js"
export * from "./CategoriaDeArvore.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=f8d7fc06&prod&scoped=true&lang=css&external"
import style1 from "./CategoriaDeArvore.vue?vue&type=style&index=1&id=f8d7fc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d7fc06",
  null
  
)

export default component.exports